import { Injectable } from '@angular/core';
import {
  SystemsListFiltersPayload,
  SystemsListWarrantyFilter,
} from '../interfaces/systems-list-filters';

export interface SystemsListState {
  currentPage: number;
  orderby_creation: string | null;
  orderby_modelbattery: string | null;
  filters: {
    statusCodes: string[] | null;
    warranty: SystemsListWarrantyFilter | null;
  };
  search: {
    query: string | null;
  };
}

@Injectable({
  providedIn: 'root',
})
export class SystemsListStateService {
  private state: SystemsListState = {
    currentPage: 1,
    orderby_creation: 'desc',
    orderby_modelbattery: null,
    filters: {
      statusCodes: null,
      warranty: null,
    },
    search: {
      query: null,
    },
  };

  /** ID stato impostato dalla dashboard home (consumato una volta sola). */
  private _dashboardStatusId: number | null = null;

  getState(): SystemsListState {
    return {
      ...this.state,
      filters: { ...this.state.filters },
      search: { ...this.state.search },
    };
  }

  setPagination(
    currentPage: number,
    orderby_creation?: string | null,
    orderby_modelbattery?: string | null,
  ): void {
    this.state.currentPage = currentPage;
    if (orderby_creation !== undefined) {
      this.state.orderby_creation = orderby_creation;
    }
    if (orderby_modelbattery !== undefined) {
      this.state.orderby_modelbattery = orderby_modelbattery;
    }
  }

  setFilters(filters: SystemsListFiltersPayload): void {
    this.state.filters.statusCodes = [...filters.statusCodes];
    this.state.filters.warranty = filters.warranty;
  }

  /** Resetta tutto e memorizza lo stato da applicare dalla dashboard home. */
  setStatusFilterFromDashboard(statusId: number): void {
    this.state = {
      currentPage: 1,
      orderby_creation: 'desc',
      orderby_modelbattery: null,
      filters: { statusCodes: null, warranty: null },
      search: { query: null },
    };
    this._dashboardStatusId = statusId;
  }

  consumeDashboardStatusId(): number | null {
    const id = this._dashboardStatusId;
    this._dashboardStatusId = null;
    return id;
  }

  setSearch(query: string | null): void {
    this.state.search.query = query;
  }

  clearFilters(): void {
    this.state.filters.statusCodes = null;
    this.state.filters.warranty = null;
    this.state.search.query = null;
    this.state.currentPage = 1;
    this.state.orderby_creation = 'desc';
    this.state.orderby_modelbattery = null;
    this._dashboardStatusId = null;
  }

  reset(): void {
    this.state = {
      currentPage: 1,
      orderby_creation: 'desc',
      orderby_modelbattery: null,
      filters: {
        statusCodes: null,
        warranty: null,
      },
      search: {
        query: null,
      },
    };
    this._dashboardStatusId = null;
  }
}
